export enum NotificationChannelTypes {
	IN_APP = 'inApp',
	SMS = 'sms',
	PUSH = 'push',
}
